<template>
  <div>
    <div>
      <div class="row">
        <div>
          <div class="demo-app">
            <AdvanceFilterModal
              :resources="resources"
              :users="users"
              @updatedResources="updateResources"
              @updateGroup="setGroup"
              @updateStructure="setStructure"
              @updateManager="setManager"
              @updateStatus="setStatus"
              @updateLeaveTypes="setLeaveTypes"
            />
            <modal
              name="user-modal"
              :classes="['modal-basic', 'modal-rotate']"
              @opened="opened"
              ref="abc"
            >
              <userInfo :users="users" :userId="userId" />
            </modal>
            <div class="left-bar-header pl-3">
              <div class="input-group">
                <input
                  v-model="search"
                  id="firstName"
                  name="firstName"
                  type="text"
                  autofocus
                  placeholder="Prénom"
                  class="form-control"
                />
                <div class="input-group-append">
                  <button
                    class="btn search-icon"
                    type="button"
                    @click="fetchUsers()"
                  >
                    <i class="fa fa-search"></i>
                  </button>
                </div>
                <a
                  id="advanceFilterButton"
                  class="advanced-filter"
                  href="#"
                  @click="showFilterModal()"
                >
                  {{ $t("planing.searchButtonText") }}
                </a>
              </div>
              <div class="legend-rock-main">
                <ul class="legend-rock">
                  <li>Congé</li>
                  <li>Absence Temporaire</li>
                  <li>Médicale</li>
                  <li>Formation</li>
                  <li>Jour de repos</li>
                  <li>Récupération d'heures supplémentaires</li>
                </ul>
              </div>
            </div>
            <FullCalendar
              class="demo-app-calendar"
              ref="fullCalendar"
              :defaultView="whichView"
              :resourceAreaWidth="calanderWidth"
              :selectable="true"
              :editable="false"
              locale="fr"
              :firstDay="1"
              :custom-buttons="customButtons"
              :header="{
                left: '',
                center: 'title',
                right: 'prev,next,week,month',
              }"
              :views="{
                week: {
                  type: 'resourceTimelineWeek',
                  duration: { days: 7 },
                  slotDuration: { days: 1 },
                  buttonText: $t('planing.monthText'),
                },
                month: {
                  type: 'resourceTimelineMonth',
                  duration: { days: 30 },
                  slotDuration: { days: 1 },
                  buttonText: $t('planing.weekText'),
                },
                // year: {
                //   type: 'resourceTimelineYear',
                //   duration: { days: 365 },
                //   slotDuration: {months: 1},
                //   buttonText: $t('planing.yearText')
                // },
                leave: {
                  type: 'resourceTimeline',
                  visibleRange: {
                    start: !this.leaveData || this.leaveData.start,
                    end: !this.leaveData || this.leaveData.end,
                  },
                  slotDuration: { days: 1 },
                  buttonText: 'leave',
                },
              }"
              :resourceLabelText="$t('planing.title')"
              :resources="filteredUsers"
              :plugins="calendarPlugins"
              :dayRender="handleDayRender"
              :resourceRender="handleSelect"
              :eventRender="renderEvent"
              :viewSkeletonRender="renderView"
              :events="getEvents"
              :eventColor="eventColor"
              :eventTextColor="eventTextColor"
            >
            </FullCalendar>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<!--  -->
<script>
let tooltipText;

import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import resourceTimelinePlugin from "@fullcalendar/resource-timeline";
import listPlugin from "@fullcalendar/list";
import groups from "@/data/groups/Groups";
import userInfo from "./userInfo";
import AdvanceFilterModal from "./AdvanceFilterModal";
import TimeUtils from "../../utils/TimeUtils";
import Long from "long";

export default {
  async mounted() {
    await this.fetchUsers();
    const fc = this.$refs.fullCalendar.getApi();
    const d = fc.state.currentDate;
    this.year = d.getFullYear();
  },

  beforeDestroy() {
    this.$store.state.planing.leaveData = null;
  },

  components: {
    FullCalendar, // make the <FullCalendar> tag available
    userInfo,
    AdvanceFilterModal,
  },

  data() {
    return {
      users: [],
      userId: -1,
      selected: {
        groups: [],
        structures: [],
        managers: [],
        status: [],
        leaveTypes: [],
      },
      advanceFilterResources: [],
      groups,
      filters: [],
      leaveStatus: "",
      y: 0, // to capture modal status if user clicks on same use
      left: 0,
      search: "",
      calendarPlugins: [
        // plugins must be defined in the JS
        dayGridPlugin,
        timeGridPlugin,
        interactionPlugin,
        listPlugin,
        resourceTimelinePlugin, // needed for dateClick
      ],
      calendarWeekends: true,
      calendarEvents: [],
      resources: [],
      resourcesPosition: [],
      events: [],
      eventColor: "#ffb400",
      eventTextColor: "white",
      year: -1,
      dayOff: -1,
      customButtons: {
        prev: {
          // this overrides the prev button
          text: "<",
          click: () => {
            if (this.leaveData) {
              this.setLeaveViewWithArrows("-");
            } else {
              const calendarApi = this.$refs.fullCalendar.getApi();
              calendarApi.prev();
              const year = calendarApi.state.currentDate.getFullYear();
              this.year = year < this.year ? year : this.year;
              this.getResourcesPositions();
            }
          },
        },
        next: {
          // this overrides the next button
          text: ">",
          click: () => {
            if (this.leaveData) {
              this.setLeaveViewWithArrows("+");
            } else {
              const calendarApi = this.$refs.fullCalendar.getApi();
              calendarApi.next();
              const year = calendarApi.view.activeEnd.getFullYear();
              this.year = year > this.year + 1 ? year : this.year;
              this.getResourcesPositions();
            }
          },
        },
      },
    };
  },

  computed: {
    calanderWidth() {
      return window.screen.width <= 767 ? "180px" : "350px";
    },

    whichView() {
      return !this.$store.state.planing.leaveData ? "month" : "leave";
    },

    leaveData() {
      return this.$store.state.planing.leaveData;
    },

    particularDayOff() {
      const date = new Date(this.year, `0${0}`, `0${1}`);
      while (date.getDay() != this.dayOff) {
        date.setDate(date.getDate() + 1);
      }
      const days = [];
      while (date.getFullYear() <= this.year + 1) {
        const year = date.getFullYear();
        const m = date.getMonth() + 1;
        const d = date.getDate();
        days.push(`${year}-${m < 10 ? `0${m}` : m}-${d < 10 ? `0${d}` : d}`);
        date.setDate(date.getDate() + 7);
      }
      return days;
    },

    dayOffUsersObj() {
      const users = [];
      this.users.forEach((u) => {
        users.push({
          reference: u.reference,
          dayOff: u.information.dayOff || false,
        });
      });
      return users;
    },

    getEvents() {
      const allAbsentObjs = [];
      this.events = [];
      this.dayOffUsersObj.forEach((u) => {
        if (u.dayOff) {
          this.dayOff = u.dayOff;
          this.particularDayOff.forEach((val) => {
            this.events.push({
              resourceId: u.reference,
              id: u.reference,
              title: "",
              start: val,
              end: val,
              color: "#CACFD2",
            });
          });
        }
      });
      this.users.forEach((absentArray) => {
        absentArray.absence.forEach((absentObj) => {
          allAbsentObjs.push(absentObj);
        });
      });
      let i = 0;
      const leaveTypes = this.selected.leaveTypes.length
        ? this.selected.leaveTypes
        : [
            "DAYS_OFF",
            "SIMPLE_ABSENCE",
            "RECOVERY_TIME_REQUEST",
            "Médicale",
            "Formation",
          ];
      const defaultLeaveStatus = ["accepted"];
      !this.leaveData || defaultLeaveStatus.push("Pending");
      allAbsentObjs.forEach((data) => {
        const status =
          this.selected.status.length <= 0
            ? defaultLeaveStatus
            : this.selected.status;
        if (
          status.includes(this.getIcon(data.status || "PENDING")) &&
          leaveTypes.includes(data.type)
        ) {
          this.events.push({
            resourceId: data.userReference.toString(),
            id: data.userReference.toString(),
            title: "",
            // start: TimeUtils.formatDateForCalander(data.dates[0].from),
            // end: TimeUtils.formatDateForCalander(data.dates[0].to),
            start: data.fromDate
              ? data.fromDate
              : new Date(
                  parseInt(
                    new Long(
                      data.dates[0].from.low,
                      data.dates[0].from.high,
                      data.dates[0].from.unsigned
                    ).toNumber()
                  )
                ),
            end: data.toDate
              ? data.toDate
              : new Date(
                  parseInt(
                    new Long(
                      data.dates[0].to.low,
                      data.dates[0].to.high,
                      data.dates[0].to.unsigned
                    ).toNumber()
                  )
                ),
            color: this.getBackgroundColor(data.type),
            description: this.getReason(data.model, data.type),
            toolTipId: i,
            className: this.getIcon(data.status || "PENDING"),
            leaveReference: data.reference,
          });
          i++;
        }
      });
      return this.events;
    },

    filteredUsers() {
      if (
        this.selected.groups.length <= 0 &&
        this.selected.structures.length <= 0 &&
        this.selected.managers.length <= 0
      ) {
        this.resources = [];
        let i = 0;
        this.users.filter((user) => {
          if (
            user.firstName.toLowerCase().match(this.search.toLowerCase()) ||
            user.lastName.toLowerCase().match(this.search.toLowerCase()) ||
            user.firstName.toUpperCase().match(this.search.toUpperCase()) ||
            user.lastName.toUpperCase().match(this.search.toUpperCase())
          ) {
            this.resources.push({
              id: user.reference,
              title: user.firstName.concat(" ", user.lastName),
              resourcePosition: i,
            });
            i++;
          }
        });
      } else {
        this.resources = [];
        let i = 0;
        this.advanceFilterResources.filter((user) => {
          if (
            user.title.toLowerCase().match(this.search.toLowerCase()) ||
            user.title.toUpperCase().match(this.search.toUpperCase())
          ) {
            this.resources.push({
              id: user.id,
              title: user.title,
              resourcePosition: i,
            });
          }
          i++;
        });
      }
      this.getResourcesPositions();
      return this.resources;
    },
  },

  methods: {
    opened(e, info) {
      e.ref.style.cssText = `top: ${this.y}px; left: ${this.left}px; width: 400px; height: 500px;`;
    },

    getReason(obj, type) {
      let reason = "";
      if (type == "DAYS_OFF") {
        reason = obj.urgent ? obj.motifUrgent : "";
      } else if (type == "SIMPLE_ABSENCE") {
        reason = obj.reason;
      } else {
        reason = obj.comments;
      }
      return reason;
    },

    setLeaveViewWithArrows(symbol) {
      const start = new Date(this.leaveData.start);
      const end = new Date(this.leaveData.start);
      if (symbol == "+") {
        start.setDate(start.getDate() + 7);
        end.setDate(end.getDate() + 13);
      } else {
        start.setDate(start.getDate() - 7);
        end.setDate(end.getDate() - 1);
      }
      this.leaveData.end = end;
      this.leaveData.start = start;
    },

    formatMonthAndDate(value) {
      return value < 10 ? `0${value}` : value;
    },

    getIcon(status) {
      let clas = "";
      if (status === "PENDING") {
        clas = "Pending";
      } else if (status === "ACCEPTED") {
        clas = "accepted";
      } else {
        clas = "rejected";
      }
      return clas;
    },

    getBackgroundColor(type) {
      let backgroundColor = "";
      if (type == "SIMPLE_ABSENCE") {
        backgroundColor = "#FFC542";
      } else if (type == "DAYS_OFF") {
        backgroundColor = "#82C43C";
      } else if (type == "Médicale") {
        backgroundColor = "#EF2A13";
      } else if (type == "Formation") {
        backgroundColor = "#50B5FF";
      } else {
        backgroundColor = "#0D0D0D";
      }
      return backgroundColor;
    },

    handleSelect(info) {
      info.el.onclick = async () => {
        this.$modal.hide("user-modal");
        this.userId = info.resource.id; // actual user id
        this.y =
          100 +
          this.resourcesPosition[info.resource.extendedProps.resourcePosition];
        this.left = this.$store.state.user.isCollapse ? 400 : 500;
        this.$modal.show("user-modal");
      };
    },

    fetchUsers() {
      this.$services.user.getUsers().then((res) => {
        this.users = res.data;
      });
    },

    toggleWeekends() {
      this.calendarWeekends = !this.calendarWeekends; // update a property
    },

    gotoPast() {
      const calendarApi = this.$refs.fullCalendar.getApi(); // from the ref="..."
      calendarApi.gotoDate("2000-01-01"); // call a method on the Calendar object
    },

    renderEvent(info) {
      if (info.event.extendedProps.toolTipId) {
        info.el.onclick = async () => {
          const toolTip = document.getElementById("toolTip");
          if (toolTip) {
            toolTip.remove();
          }

          // managing the z-index of the parent div
          info.el.parentNode.parentNode.style.zIndex = 10;
          const siblings =
            info.el.parentNode.parentNode.parentNode.parentNode.nextSibling;
          if (siblings) {
            siblings.childNodes[0].childNodes[0].style.zIndex = 0;
          }

          // parent div
          tooltipText = document.createElement("div");
          tooltipText.style.position = "absolute";
          (tooltipText.style.transform = `translate3d(${91}px`),
            `${792}px`,
            `${0}px)`;
          tooltipText.style.top = `${44}px`;
          tooltipText.style.left = `${0}px`;
          tooltipText.style.willChange = "transform";
          tooltipText.setAttribute("id", "toolTip");
          tooltipText.classList.add("tool-tip-arrow", "tool-tip-width");

          // div to hold tooltip-header
          const header = document.createElement("h3");
          header.classList.add("tool-tip-header");
          const anchor = document.createElement("a");
          anchor.text = this.$t("planing.toolTip.header");
          anchor.classList.add("tool-tip-header-link");
          header.appendChild(anchor);
          tooltipText.appendChild(header);

          // div hold to tol-tip-body
          if (info.event.extendedProps.description) {
            tooltipText.classList.add("tool-tip-text-bottom");
            const body = document.createElement("div");
            body.classList.add("tool-tip-body");
            const bodyText = document.createElement("span");
            bodyText.innerText = info.event.extendedProps.description;
            body.appendChild(bodyText);
            tooltipText.appendChild(body);
          }

          anchor.onclick = () => {
            this.$router.push(
              `demandes/repondre/${info.event.extendedProps.leaveReference}`
            );
          };
          info.el.appendChild(tooltipText);
        };
      }
    },

    handleDayRender(info, el) {
      const today = info.date;
      if (today.getDay() == 0) {
        info.el.bgColor = "#CACFD2";
      }
    },

    renderView(info) {
      this.getResourcesPositions();
    },

    async getResourcesPositions() {
      const fcContentWidget = await document.getElementsByClassName(
        "fc-widget-content"
      );
      this.resourcesPosition = [];
      for (let i = 0; i < this.resources.length; i++) {
        this.resourcesPosition[i] = fcContentWidget[i + 1].offsetTop;
      }
    },

    setGroup(groups) {
      this.selected.groups = groups;
    },

    setStructure(structure) {
      this.selected.structures = structure;
    },

    setManager(manager) {
      this.selected.managers = manager;
    },

    setStatus(status) {
      this.selected.status = status;
    },

    setLeaveTypes(leaves) {
      this.selected.leaveTypes = leaves;
    },

    updateResources(res) {
      this.advanceFilterResources = this.resources = res;
    },

    showFilterModal() {
      this.$modal.show("filter-modal");
    },
  },
};
</script>
<style lang="scss">
@import "~@fullcalendar/core/main.css";
@import "~@fullcalendar/daygrid/main.css";
@import "~@fullcalendar/timegrid/main.css";
@import "~@fullcalendar/timeline/main.css";
@import "~@fullcalendar/resource-timeline/main.css";
@import "~@fullcalendar/list/main.css";
@mixin list-dots {
  position: relative;
  &:before {
    content: "";
    width: 5px;
    height: 5px;
    border-radius: 100%;
    position: absolute;
    left: 3px;
    top: 7px;
  }
}
.tool-tip-arrow {
  :after {
    content: "";
    width: 0px;
    height: 0px;
    border-bottom: 10px solid #007bff;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    position: absolute;
    left: 10px;
    top: -7px;
  }
}
.tool-tip-width {
  width: 250px;
}
.tool-tip-text-bottom {
  color: black;
  z-index: 1060;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;
  font-style: normal;
  font-weight: 300;
  line-height: 1.5;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  word-spacing: normal;
  white-space: normal;
  line-break: auto;
  font-size: 0.6875rem;
  background-color: #fff;
  border: none;
  padding: 0;
  border-radius: 0.5rem;
  -webkit-box-shadow: 0 3px 15px rgba(90, 97, 105, 0.1),
    0 2px 3px rgba(90, 97, 105, 0.2);
  box-shadow: 0 3px 15px rgba(90, 97, 105, 0.1),
    0 2px 3px rgba(90, 97, 105, 0.2);
}
.tool-tip-header {
  padding: 8px 0 8px 0;
  font-size: 1rem;
  color: white;
  line-height: normal;
  background-color: #007bff;
  border-bottom: 1px solid #e7e9ea;
  border-top-left-radius: calc(0.5rem - 1px);
  border-top-right-radius: calc(0.5rem - 1px);
  text-align: center;
  cursor: pointer;
}
.tool-tip-header-link {
  float: none;
  color: white !important;
  padding: 0 !important;
  margin: 0 !important;
  height: auto !important;
  border: 0;
}
.tool-tip-body {
  color: black;
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 10px;
  text-align: left;
  font-weight: 300;
}
.Pending:before {
  content: "";
  background-image: url("~@/assets/images/clock-regular.svg");
  font-weight: bold;
  width: 50px;
  height: 23px;
  padding-left: 15px;
  background-repeat: no-repeat;
  background-position: center;
  cursor: pointer;
}
.accepted:before {
  content: "";
  background-image: url("~@/assets/images/check-solid.svg");
  width: 50px;
  height: 23px;
  padding-left: 15px;
  background-repeat: no-repeat;
  background-position: center;
  cursor: pointer;
}
.rejected:before {
  content: "";
  background-image: url("~@/assets/images/times-solid.svg");
  width: 50px;
  height: 23px;
  padding-left: 25px;
  background-repeat: no-repeat;
  background-position: center;
  cursor: pointer;
}
.fc-event-container {
  a {
    height: 25px;
    margin-top: 10px;
    padding: 5px;
  }
}

.v--modal-overlay {
  background: rgba(0, 0, 0, 0);
  left: 250px;
  position: absolute;
  .v--modal-box {
    @media screen and (min-width: 768px) and (max-width: 1000px) {
      width: 65% !important;
      margin: 0 auto !important;
      left: 13% !important;
    }
    @media (max-width: 767px) {
      width: 90% !important;
      margin: 0 auto;
      left: 0 !important;
    }
  }
}
.demo-app {
  font-family: Arial, Helvetica Neue, Helvetica, sans-serif;
  font-size: 14px;
}
.demo-app-top {
  margin: 0 0 3em;
}

.demo-app-calendar {
  margin: 0 auto;
  max-width: 100%;
}

.left-bar-header {
  width: 300px;
  margin-top: 0;
  margin-bottom: 0;
  position: absolute;
  top: 11px;
  @media screen and (min-width: 768px) and (max-width: 1000px) {
    width: 90%;
    position: relative;
    margin: 0;
    background-color: #fff;
    padding: 0;
    top: 0;
    .input-group {
      width: 100%;
      padding: 20px;
    }
  }
  @media screen and (min-width: 768px) and (max-width: 1100px) {
    top: 0;
    .input-group {
      width: 100%;
      padding: 16px 17px 60px 0px;
    }
  }
  @media (max-width: 767px) {
    width: 100%;
    position: relative;
    margin: 0;
    background-color: #fff;
    padding: 0 15px !important;
    top: 0;
    .input-group {
      width: 100%;
      padding: 30px 20px 60px 20px;
    }
  }
  .search-icon {
    background-color: #fff;
    border: 1px solid #ddd !important;
  }
  .advanced-filter {
    display: inline-block;
    margin-left: 10px;
    background-color: #538f92;
    height: 32px;
    border-radius: 5px;
    padding: 0 6px;
    line-height: 30px;
    color: #fff;
    font-size: 14px;
    text-decoration: none;
    &:hover {
      color: #fff;
      text-decoration: none;
    }
  }
}
.legend-rock {
  position: absolute;
  top: -3px;
  left: 313px;
  width: 316px;
  margin: 0;
  line-height: normal;
  padding: 0;
  @media screen and (min-width: 1651px) and (max-width: 2500px) {
    top: 10px;
    left: 350px;
    width: 600px;
  }
  @media screen and (min-width: 1401px) and (max-width: 1650px) {
    left: 320px;
    width: 400px;
  }
  @media screen and (min-width: 1300px) and (max-width: 1400px) {
    left: 320px;
    width: 370px;
  }
  @media screen and (min-width: 768px) and (max-width: 1100px) {
    display: none;
    top: 81px;
    left: 40px;
    width: 100%;
  }
  @media screen and (min-width: 320px) and (max-width: 767px) {
    top: 71px;
    left: 40px;
    width: 100%;
  }
  li {
    display: inline-block;
    list-style-type: none;
    padding: 0 15px;
    &:first-child {
      @include list-dots;
      &:before {
        background-color: #82c43c;
      }
    }
    &:nth-of-type(2) {
      @include list-dots;
      &:before {
        background-color: #ffc542;
      }
    }
    &:nth-of-type(3) {
      @include list-dots;
      &:before {
        background-color: #ef2a13;
      }
    }
    &:nth-of-type(4) {
      @include list-dots;
      &:before {
        background-color: #50b5ff;
      }
    }
    &:nth-of-type(5) {
      @include list-dots;
      &:before {
        background-color: #cacfd2;
      }
    }
    &:nth-of-type(6) {
      @include list-dots;
      &:before {
        background-color: #0d0d0d;
      }
    }
  }
}
.fc-view-container {
  @media (max-width: 767px) {
    width: 90% !important;
    margin: 0 auto !important;
  }
}
.fc-header-toolbar {
  margin-bottom: 0 !important;
  padding: 11px 20px;
  background-color: #fff;
  border-top: 1px solid #ddd;
  @media (max-width: 767px) {
    padding: 10px 20px 25px 40px;
  }
}
.fc-header-toolbar .fc-center {
  margin-left: 0;
  display: grid;
  justify-content: right;
  width: 100%;
  padding-right: 10px;
  @media screen and (min-width: 768px) and (max-width: 1000px) {
    margin-left: 0;
  }
  @media (max-width: 767px) {
    display: block;
  }
}
@media (max-width: 767px) {
  .fc-cell-text {
    font-size: 12px;
  }
}
.fc-toolbar {
  h2 {
    font-size: 1.3rem;
  }
  @media screen and (min-width: 768px) and (max-width: 1000px) {
    h2 {
      font-size: 1rem;
    }
  }
  @media (max-width: 767px) {
    display: block;
    h2 {
      font-size: 1rem;
    }
  }
}
.fc-button-primary {
  color: #fff;
  background-color: #538f92;
  border-color: #538f92;
  &:hover {
    background-color: #86b6b8;
    border-color: #86b6b8;
  }
}
.fc-ltr .fc-timeline-event {
  border-radius: 2px;
}
.fc-button-primary:not(:disabled):active,
.fc-button-primary:not(:disabled).fc-button-active {
  background-color: #86b6b8;
  border-color: #86b6b8;
}
.fc-button-primary {
  &:focus {
    box-shadow: none !important;
  }
}

.attendance-modal-header {
  border-bottom: 1px solid #ddd;
  padding: 0 20px;
  .modal-header-left {
    h3 {
      font-size: 18px;
      margin: 0;
      padding: 7px 0;
      color: #9a9898;
    }
  }
  .modal-header-right {
    border-left: 1px solid #dddd;
    padding-left: 15px;
    padding: 7px 0;
    a {
      cursor: pointer;
      display: inline-block;
      padding-top: 10px;
      padding-left: 15px;
    }
  }
}
.vacation-section {
  padding: 10px 20px;
  .vacation-number {
    width: 50px;
    height: 50px;
    border: 3px solid #86b6b8;
    border-radius: 50px;
    text-align: center;
    line-height: 40px;
    margin-right: 10px;
    p {
      margin: 0;
      font-size: 20px;
    }
  }
  .vacation-details {
    margin-right: 10px;
    h4 {
      margin: 0;
      font-size: 17px;
      font-weight: 700;
    }
    p {
      margin: 0;
    }
  }
  .vacation-account {
    ul {
      margin: 29px 0 0 0;
      padding: 0;
      text-align: right;
    }
    li {
      list-style-type: none;
      width: 50%;
      float: left;
    }
  }
}
.modal-left-bar {
  width: 200px;
  background-color: #f6f7f8;
  border-right: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  max-height: 300px;
  height: 200px;
  overflow-y: auto;
  @media (max-width: 767px) {
    height: 100vh;
    width: 150px;
  }
  ul {
    margin: 0;
    padding: 0;
    li {
      list-style-type: none;
    }
    a {
      text-decoration: none;
      padding: 7px 15px;
      display: inline-block;
      width: 100%;
      transition: 0.5s;
      font-weight: 700;
      color: #5a5a5a;
      @media (max-width: 767px) {
        font-size: 12px;
      }
      &:hover {
        background-color: #e7e4e4;
      }
    }
  }
}
.checkbox-main {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 16px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }
  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 20px;
    width: 20px;
    background-color: transparent;
    border: 2px solid #86b6b8;
    &:after {
      content: "";
      position: absolute;
      display: none;
    }
    &:after {
      left: 5px;
      top: 0px;
      width: 7px;
      height: 12px;
      border: solid #fff;
      border-width: 0 2px 2px 0;
      -webkit-transform: rotate(45deg);
      transform: rotate(45deg);
    }
  }
  &:hover {
    input ~ .checkmark {
      background-color: transparent;
    }
  }
  input:checked ~ .checkmark {
    background-color: #86b6b8;
    &:after {
      display: block;
    }
  }
}
.fc-license-message {
  @media (max-width: 767px) {
    z-index: 100 !important;
  }
}
</style>
